"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dcCore = require("dc-core");
var _saveFile = _interopRequireDefault(require("../preview/actions/saveFile"));
var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _CallbackTypes = _interopRequireDefault(require("../constants/CallbackTypes"));
var _ApiConstants = _interopRequireDefault(require("../constants/ApiConstants"));
var _AppUtil = require("../util/AppUtil");
var _Events = _interopRequireWildcard(require("../constants/Events"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
/**
 * @class
 * @description
 * Polling service for File Save
 */
class PollingService {
  constructor() {
    this.pollingConfig = {};
    this.firstTimePoll = true;
    this.pollingInProgress = false;
    this.filePollCounter = 0;
  }
  /**
   * @method
   * @description
   * polling service is required if either commenting or form filling enabled.
   * initializing the service start once the file preview is done.
   */
  initialize() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.InternalEvents.PREVIEW_REF_READY, () => {
      const previewConfig = appStore.getActionConfig("preview");
      if (!previewConfig.showAnnotationTools && !previewConfig.enableFormFilling) {
        return;
      }
      if (appStore.configStore.getPollingConfig().keepPolling) {
        _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.default.APP_RENDERING_DONE, () => {
          this.startPolling();
        });
      }
      appStore.previewRef.getApis("INTEGRATION_CONNECTOR", ["document"]).then(apiObject => apiObject.document.subscribeToPDFEditOperations(() => apiObject.document.isDirty().then(isDirty => {
        if ((appStore.isInPreview || appStore.isInEdit) && !appStore.preventDirtyPDF) {
          if (this.firstTimePoll) {
            this.pollFile();
            this.firstTimePoll = false;
          }
          this.pollingAction(isDirty);
          appStore.setIsDirty(isDirty);
        }
      }))).catch(error => {
        _ServiceRegistry.default.getService("LoggingService").error("PollingService", `Error in calling preview dirty apis: ${JSON.stringify(error)}`);
      });
    });
    _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.InternalEvents.POLLING_CONFIG_UPDATE, () => {
      this._resetPollerAndUpdatePollingConfig();
    });
  }
  /**
   * @method
   * @description
   * reset the polling service by restoring counter to zero
   */
  _resetPoller() {
    this.filePollCounter = 0;
    this.pollCounter = 0;
  }

  /**
   * @method
   * @description
   * set/update polling config and reset counters
   */
  _resetPollerAndUpdatePollingConfig() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    this.pollingConfig = appStore.configStore.getPollingConfig();
    this._resetPoller();
  }

  /**
   * @method
   * @description
   * enable or disable the polling service.
   *
   * @param start polling start if param is true else stop
   */
  pollingAction(start) {
    if (start) {
      this.startPolling();
    } else {
      this.stopPolling();
    }
  }

  /**
   * @method
   * @description
   * start the polling for the file save whether it is modified or not. It also check
   * for the auto save if it cross the time threshold or it is in non focus mode.
   */
  startPolling() {
    document.addEventListener("keydown", this.handleKeyDown.bind(this));
    this._resetPollerAndUpdatePollingConfig();
    if (!this.poller) {
      this.poller = setInterval(() => {
        this.pollCounter += 1;
        this.filePollCounter += 1;

        // File Polling
        if (this.filePollCounter === this.pollingConfig.filePollFrequency && this.pollingConfig.filePollFrequency > 0) {
          this.pollFile();
        }

        // AutoSave
        if (this.pollCounter === this.pollingConfig.autoSaveFrequency && this.pollingConfig.autoSaveFrequency > 0) {
          (0, _saveFile.default)({}, _AppConstants.default.SAVE_COMMENT_TYPE.AUTO_SAVE_FREQUENCY).catch(() => {});
        }

        // Focus Polling
        if (!document.hasFocus() && this.pollingConfig.enableFocusPolling) {
          (0, _saveFile.default)({}, _AppConstants.default.SAVE_COMMENT_TYPE.AUTO_SAVE_FOCUS).catch(() => {});
        }
      }, 1000);
    }
  }

  /**
   * @method
   * @description
   * stop the polling service for file save and reset the counter
   */
  stopPolling() {
    clearInterval(this.poller);
    this.poller = undefined;
    this._resetPoller();
  }
  handleKeyDown(event) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const charCode = String.fromCharCode(event.which).toLowerCase();
    if ((event.metaKey || event.ctrlKey) && charCode === "s") {
      event.preventDefault();
      if (appStore.isInPreview) {
        (0, _saveFile.default)({}, _AppConstants.default.SAVE_COMMENT_TYPE.AUTO_SAVE_KEYDOWN).catch(() => {});
      }
    }
    this._resetPoller();
  }
  showConflictDialog(isFirstTime, result, resolve) {
    const event = {
      workflow: "preview",
      subcategory: "updated check",
      type: isFirstTime ? "GET LATEST FILE" : "CONFLICT"
    };
    _ServiceRegistry.default.getService("AnalyticsProviderService").logEvent(event, {});
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const shouldShowNewFileDialog = appStore.isIntegration && (result === null || result === void 0 ? void 0 : result.showNewFileDialog);
    const isNotDirty = !appStore.isDirty;
    if (isFirstTime || shouldShowNewFileDialog || isNotDirty) {
      _ServiceRegistry.default.getService("DialogApi").showNewFileDialog(_objectSpread({}, result.data.modifiedBy));
    } else {
      (0, _saveFile.default)(result).catch(() => {});
    }
    resolve();
    this.pollingInProgress = false;
  }

  /**
   * @method
   * @description
   * it check at regular interval whether the current file is the latest one or not
   */
  pollFile() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const previewConfig = appStore.getActionConfig("preview");
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    if (appStore.fileStatus === _AppConstants.default.FILE_PROGRESS_STATUS.SAVING || this.pollingInProgress || !callbackService.hasCallback(_CallbackTypes.default.STATUS_API) || previewConfig.enableCNPDF) {
      return;
    }
    // eslint-disable-next-line no-unused-vars
    const errorHandler = error => {
      this.pollingInProgress = false;
      // handler error if needed
    };
    this.pollingInProgress = true;
    const firstTime = this.firstTimePoll;
    const isFileUpdated = callbackService.getCallback(_CallbackTypes.default.STATUS_API);
    const postDraftCommentOnConflict = !!previewConfig.postDraftCommentOnConflict;
    const isInPreview = appStore.isInPreview;
    const hasAnnotationTools = !appStore.shouldHideAnnotationTools;
    const isFullFileLoaded = appStore.isFullFileLoaded();
    const commentPostableState = isInPreview && hasAnnotationTools && isFullFileLoaded;
    const postDraftComment = commentPostableState && postDraftCommentOnConflict ? () => _dcCore.providers["comments-provider"]().then(commentsProvider => commentsProvider.postDraftComment()).catch() : () => Promise.resolve();
    isFileUpdated((0, _AppUtil.deepCopyObject)(appStore.fileInfoList[0].metaData)).then(result => {
      if (result.code === _ApiConstants.default.API_RESPONSE.FILE_MODIFIED) {
        this.stopPolling();
        postDraftComment().then(() => new Promise(res => {
          if (postDraftCommentOnConflict) {
            setTimeout(() => {
              this.showConflictDialog(this.firstTimePoll, result, res);
            }, 1000);
          } else {
            this.showConflictDialog(firstTime, result, res);
          }
        }));
      } else {
        this.filePollCounter = 0;
        this.pollingInProgress = false;
      }
    }).catch(errorHandler);
  }
}
exports.default = PollingService;